module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    key: _vm.isActive,
    staticClass: "content"
  }, [(_vm.isPasswordRest) ? _c('div', {
    staticClass: "password-popup"
  }, [_c('vue-form', {
    staticClass: "ui form loginForm",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkAndResetPassword($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('a', {
    staticClass: "toggle",
    on: {
      "click": function($event) {
        _vm.isPasswordRest = false
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "800px",
      "height": "800px",
      "viewBox": "0 0 503.021 503.021",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M491.613,75.643l-64.235-64.235c-15.202-15.202-39.854-15.202-55.056,0L251.507,132.222L130.686,11.407\n\n        c-15.202-15.202-39.853-15.202-55.055,0L11.401,75.643c-15.202,15.202-15.202,39.854,0,55.056l120.821,120.815L11.401,372.328\n\n        c-15.202,15.202-15.202,39.854,0,55.056l64.235,64.229c15.202,15.202,39.854,15.202,55.056,0l120.815-120.814l120.822,120.814\n\n        c15.202,15.202,39.854,15.202,55.056,0l64.235-64.229c15.202-15.202,15.202-39.854,0-55.056L370.793,251.514l120.82-120.815\n\n        C506.815,115.49,506.815,90.845,491.613,75.643z"
    }
  })])])])]), _vm._v(" "), _c('h2', [_vm._v("Reset Password")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.newPassword),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "newPassword",
      "id": "password",
      "placeholder": "Enter Password",
      "type": "password",
      "required": "",
      "pattern": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$#!%*?&]{8,}$"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback error-message",
    attrs: {
      "name": "newPassword",
      "show": "$touched || $submitted"
    }
  }, [_c('p', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Password is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                            Password should have at least one uppercase letter, one\n                            lowercase letter, one number and one special character. ( eg:\n                            Xyz@1234 )\n                        ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.passwordVerify),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordVerify),
      expression: "passwordVerify"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "passwordVerify",
      "id": "passwordVerify",
      "placeholder": "Enter Confirm password",
      "type": "password",
      "required": "",
      "pattern": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$#!%*?&]{8,}$"
    },
    domProps: {
      "value": (_vm.passwordVerify)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordVerify = $event.target.value
      }, _vm.isPasswordMatch]
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback error-message",
    attrs: {
      "name": "passwordVerify",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Confirm password is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                            Password should have at least one uppercase letter, one\n                            lowercase letter, one number and one special character. ( eg:\n                            Xyz@1234 )\n                        ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 showPassword"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.showPassword
    }
  }), _c('span', [_vm._v("Show Password")])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions resetPasswordButton"
  }, [_c('button', {
    class: 'btn btn-warning btn-lg resetPasswordButton' + _vm.loading,
    attrs: {
      "type": "submit",
      "disabled": _vm.isResetPasswordDisabled
    }
  }, [_vm._v("\n                    Reset Password\n                ")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "city_wrp_res",
    on: {
      "click": _vm.closeResetPasswordModal
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'addCity',
        params: {
          _id: '0'
        }
      }
    }
  }, [_c('button', {
    staticClass: " btn gradientbt"
  }, [_vm._v("Add City")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "cityTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp"
        }, [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.action(props.row)
            }
          }
        }), _vm._v(" "), _c('a', {
          staticClass: "fa fa-key",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.password(props.row)
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "py-2 text-center row"
        }, [_c('label', {
          staticClass: "toggle"
        }, [_c('input', {
          staticClass: "toggle-checkbox",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": props.row.status === true ? true : false
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return (function (e) { return _vm.activateCityModal(props.row); })($event)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "slider"
        })])])])]
      }
    }]),
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-298034c0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298034c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/city/city.vue
// module id = 2284
// module chunks = 0